import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import tokens from '../../theme/tokens';

const tones = {
  brand: [tokens.color.brandSoft, tokens.color.brand],
  gold: [tokens.color.goldSoft, tokens.color.gold],
  success: [tokens.color.successSoft, tokens.color.success],
  info: [tokens.color.infoSoft, tokens.color.info],
  danger: [tokens.color.dangerSoft, tokens.color.danger],
  neutral: [tokens.color.surfaceAlt, tokens.color.textMuted],
};

// Indicador numérico (KPI) com ícone e legenda.
const StatCard = ({ label, value, hint, icon, tone = 'brand' }) => {
  const [bg, fg] = tones[tone] || tones.brand;
  return (
    <Card sx={{ height: '100%' }}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 2.5 }}>
        {icon && (
          <Box sx={{ width: 48, height: 48, borderRadius: 3, bgcolor: bg, color: fg, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            {icon}
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary" noWrap>
            {label}
          </Typography>
          <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '2rem', lineHeight: 1.1 }}>
            {value}
          </Typography>
          {hint && (
            <Typography variant="caption" color="text.secondary">
              {hint}
            </Typography>
          )}
        </Box>
      </Stack>
    </Card>
  );
};

export default StatCard;
